// import modernizr from 'modernizr'
// import 'jquery-gray/js/jquery.gray'
import './children_filter'
import './phone_numbers_mobile'
import HighlitedVideo from './hightlited_video'
import CustomMenuMobile from './custom_menu_mobile'
import Sticky from './sticky'
import { checkScreenSize } from './utils'

(function ($, Drupal) {
  Drupal.behaviors.siteMain = {
    attach: function (context, settings) {
      const elParent = $('.mhg_block_highlightvideo_play')
      if( elParent.length > 0 ){
        new HighlitedVideo(elParent)
      }

      /*** Menu Mobile ***/
      let menuMobile

      if(hasMenuMobile()){
        menuMobile = instSubmenuMob()
      }

      $(document).on('DOMNodeInserted', function(e) {
        if ( $(e.target).hasClass('sf-accordion-toggle') ) {
           //console.log('.sf-accordion-toggle');
           setTimeout(() => menuMobile = instSubmenuMob())
        }
      });

      $( window ).resize(function() {
        if(!hasMenuMobile() && menuMobile){
            menuMobile.destroy()
            menuMobile = null
        }
      })

      function instSubmenuMob(){
          const elParentMenuSuperfish = $('#block-superfish-1')
          if( elParentMenuSuperfish.length > 0 && hasMenuMobile() ){
            return new CustomMenuMobile(elParentMenuSuperfish, $('#block-gootranscustom-custom-lang-switcher'))
          }
      }

      function hasMenuMobile(){
        return $('#block-superfish-1').find('.sf-accordion-toggle').length > 0;
      }
      /*--------------------------------------------------------------------------------------------------*/

      /*** Sticky Social Share ***/
      if( $('.mhg_social_share').length > 0 ){
        const socialSticky = new Sticky( $('.mhg_social_share'), 'mhg_sticky_social_share', 50 );
        $('body').addClass('mhg_children_detail_page');
      }
      /*--------------------------------------------------------------------------------------------------*/

      /*** Init ScrollReveal.js ***/
      // new WOW().init();
      if (typeof window.sr !== "undefined"){
        window.sr = ScrollReveal();
        sr.reveal('#block-views-view-children-children-list .mhg-children-list-node', { duration: 1500 });
      }
      /*--------------------------------------------------------------------------------------------------*/

      /*** Gray scale image partner ***/
      // $('.mhg_footer_right .view.view-partner-view img').gray()
      /*--------------------------------------------------------------------------------------------------*/
      /** Children List on Home Page */
      if ($('.view-display-id-children_list_home .view-content').length > 0){
        if (!$('.view-display-id-children_list_home .view-content').hasClass('slick-initialized')){
          $('.view-display-id-children_list_home .view-content').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
              {
                breakpoint: 1199,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                }
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
              // You can unslick at a given breakpoint now by adding:
              // settings: "unslick"
              // instead of a settings object
            ]
          });
        }
      }


    }
  }
})(jQuery, Drupal);



// WEBPACK FOOTER //
// ./src/index.js